/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SourceVaultBalanceDto {
  vaultId?: number;
  vaultName?: string;
  fireblocksAssetName?: string;
  /**
   * Available balance of the withdrawal\'s Fireblocks asset in the vault, zero if the vault has no such asset.
   */
  availableBalance?: number;
  /**
   * Whether the available balance covers the withdrawal quantity.
   */
  enough?: boolean;
}
